<template>
  <div class="addRole">
    <van-cell-group>
      <van-field
        v-model="listQuery.name"
        label
        :readonly="onlyRead"
        input-align="right"
        placeholder="请输入角色名称"
      >
        <template #label>
          <span class="tip">角色名称：</span>
        </template>
      </van-field>
    </van-cell-group>

    <van-cell>
      <template #title>
        <div class="tip">权限设置如下：</div>
      </template>
    </van-cell>

    <van-checkbox-group v-model="roles_id">
      <van-cell-group>
        <van-cell
          v-for="(item, index) in list"
          clickable
          :key="index"
          :title="item.name"
          @click="!onlyRead?toggle(index):''"
        >
          <template #right-icon>
            <van-checkbox
              :name="item.id"
              shape="square"
              checked-color="#31B158"
              ref="checkboxes"
              :disabled="onlyRead"
            />
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <van-button
      v-if="!onlyRead"
      type="primary"
      block
      color="#31B158"
      class="add_btn"
      @click="editRole"
    >{{listQuery.id?'保存':'添加角色'}}</van-button>

    <van-button v-if="listQuery.id>10" type="danger" block class="add_btn" @click="delRole">删除</van-button>
  </div>
</template>

<script>
import { role_all_limit, role_set, role_del } from "@/api/work/mine/role.js";
export default {
  name: "addRole",
  data() {
    return {
      list: [],
      listQuery: {
        name: "",
        id: ""
      },
      roles_id: []
    };
  },
  computed: {
    // 只读
    onlyRead() {
      if (this.listQuery.id) {
        if (this.listQuery.id <= 10) return true;
      }
      return false;
    }
  },
  created() {
    if (this.$route.query.id) {
      this.listQuery.name = this.$route.query.name;
      this.listQuery.id = this.$route.query.id;
      if (this.$route.query.roles_id.indexOf(",") < 0) {
        this.roles_id = [this.$route.query.roles_id];
      } else {
        this.roles_id = this.$route.query.roles_id.split(",");
      }
    }
    this.getList();
  },
  mounted() {},
  methods: {
    //单元格点击事件
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    delRole() {
      this.$dialog
        .confirm({
          title: "删除角色",
          message: `该角色可能已分配给员工，\n确认删除${this.listQuery.name}吗？`
        })
        .then(() => {
          role_del({ id: this.listQuery.id })
            .then(res => {
              if (res.code == 200) {
                this.$toast.success(res.message);
                this.$router.go(-1);
              }
            })
            .catch(err => {
              if (err.code == 422) {
                this.$toast({
                  duration: 5000,
                  message: err.message
                });
              }
            });
        })
        .catch(err => {});
    },
    // 修改添加角色
    editRole() {
      if (!this.listQuery.name) {
        this.$toast("请输入该角色的名称！");
        return false;
      }
      if (this.listQuery.name.length > 10) {
        this.$toast("请输入长度在10位以内的角色名称！");
        return false;
      }
      if (!this.roles_id.length) {
        this.$toast("请赋予该角色至少一个权限！");
        return false;
      }

      let obj = Object.assign({}, this.listQuery);
      if (this.roles_id.length == 1) {
        obj.roles_id = this.roles_id[0];
      } else if (this.roles_id.length > 1) {
        obj.roles_id = this.roles_id.join(",");
      } else {
        obj.roles_id = "";
      }

      role_set(obj).then(res => {
        if (res.code == 200) {
          this.$toast.success(res.message);
          this.$router.go(-1);
        }
      });
    },
    getList() {
      role_all_limit().then(res => {
        if (res.code == 200) {
          this.list = res.data;
        }
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.id) {
      to.meta.title = "修改角色配置";
    } else {
      to.meta.title = "添加角色";
    }
    next();
  }
};
</script>

<style lang="less" scoped>
.addRole {
  position: relative;
  .tip {
    font-weight: 600;
    font-size: 0.32rem;
  }
  .box {
    background-color: #fff;
    padding-left: 0.5rem;
    box-sizing: border-box;
  }
  .add_btn {
    border-radius: 0.16rem;
    width: 6.9rem;
    margin: 0.3rem auto;
  }
}
</style>